import { FC } from 'react';

interface ErrorFallbackProps {
  error: Error
}

const ErrorFallback: FC<ErrorFallbackProps> = ({ error }) => (
  <div>
    <h2>⚠️ An error has occurred!</h2>
    <p>{error.message}</p>
  </div>
);

export default ErrorFallback;
